import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${API_BASE}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Public API calls
export const getTimeSlots = () => api.get('/slots');
export const getAvailableSlots = (date) => api.get(`/available-slots/${date}`);
export const createBooking = (data) => api.post('/bookings', data);
export const getBooking = (id) => api.get(`/booking/${id}`);
export const getHomeContent = () => api.get('/home-content');
export const getFaqItems = () => api.get('/faq');
export const getMetaFacebookReviews = () => api.get('/meta/facebook-reviews');
export const getMetaFacebookPosts = (limit = 6) => api.get(`/meta/facebook-posts?limit=${limit}`);
export const getMetaInstagramFeed = (limit = 9) => api.get(`/meta/instagram-feed?limit=${limit}`);
export const trackVisit = () => api.post('/track-visit');
export const adminGetVisitorStats = () => api.get('/admin/visitor-stats');

// Admin API calls
export const adminCheckExists = () => api.get('/admin/check');
export const adminSetup = (data) => api.post('/admin/setup', data);
export const adminLogin = (data) => api.post('/admin/login', data);
export const adminCreateUser = (data) => api.post('/admin/create-user', data);
export const adminChangePassword = (data) => api.put('/admin/password', data);
export const adminGetUsers = () => api.get('/admin/users');
export const adminDeleteUser = (username) => api.delete(`/admin/users/${username}`);
export const adminGetBookings = () => api.get('/admin/bookings');
export const adminCancelBooking = (id) => api.delete(`/admin/bookings/${id}`);
export const adminApproveBooking = (id) => api.post(`/admin/bookings/${id}/approve`);
export const adminDenyBooking = (id, reason) => api.post(`/admin/bookings/${id}/deny`, { reason: reason || null });
export const adminGetBlockedSlots = () => api.get('/admin/blocked-slots');
export const adminBlockSlot = (data) => api.post('/admin/block-slot', data);
export const adminBlockDateRange = (data) => api.post('/admin/block-date-range', data);
export const adminUnblockSlot = (id) => api.delete(`/admin/block-slot/${id}`);
export const adminGetHomeContent = () => api.get('/admin/home-content');
export const adminUpdateHomeContent = (data) => api.put('/admin/home-content', data);
export const adminGetFaq = () => api.get('/admin/faq');
export const adminUpdateFaq = (data) => api.put('/admin/faq', data);
export const getChatbotConfig = () => api.get('/chatbot-config');
export const adminGetChatbotConfig = () => api.get('/admin/chatbot-config');
export const adminUpdateChatbotConfig = (data) => api.put('/admin/chatbot-config', data);
export const adminUpdateBookingCustomer = (id, data) => api.put(`/admin/bookings/${id}/customer`, data);
export const getPublicSettings = () => api.get('/settings');
export const adminGetSettings = () => api.get('/admin/settings');
export const adminGetVapidKey = () => api.get('/admin/push/vapid-public-key');
export const adminSubscribePush = (data) => api.post('/admin/push/subscribe', data);
export const adminUnsubscribePush = (data) => api.post('/admin/push/unsubscribe', data);
export const adminTestPush = () => api.post('/admin/push/test');
export const adminGetPendingCount = () => api.get('/admin/pending-count');

// Google Calendar
export const adminGoogleStatus = () => api.get('/admin/google/status');
export const adminGoogleConnect = () => api.get('/admin/google/connect');
export const adminGoogleDisconnect = () => api.post('/admin/google/disconnect');
export const adminGooglePollNow = () => api.post('/admin/google/poll-now');

// Workshop events
export const adminListWorkshopEvents = () => api.get('/admin/workshop-events');
export const adminCreateWorkshopEvent = (data) => api.post('/admin/workshop-events', data);
export const adminDeleteWorkshopEvent = (id) => api.delete(`/admin/workshop-events/${id}`);
export const adminClassifyWorkshopEvent = (id, classification) =>
  api.put(`/admin/workshop-events/${id}/classify`, { classification });
export const adminUpdateBookingsSettings = (data) => api.put('/admin/settings/bookings', data);

// Meta token status (admin)
export const adminGetMetaTokenStatus = () => api.get('/admin/meta/token-status');

// After-hours enquiries
export const submitAfterHoursEnquiry = (data) => api.post('/after-hours-enquiry', data);
export const adminListAfterHoursEnquiries = () => api.get('/admin/after-hours-enquiries');
export const adminUpdateAfterHoursEnquiryStatus = (id, status) =>
  api.put(`/admin/after-hours-enquiries/${id}/status`, { status });
export const adminDeleteAfterHoursEnquiry = (id) => api.delete(`/admin/after-hours-enquiries/${id}`);
